<script lang="ts">
// Enveloppe web d'AppLocationSearch : injecte le consentement Mapbox (cookie-consent) et
// l'orientation responsive (useIsMobile). Ré-exporte LocationFilter / DEFAULT_RADIUS_OPTIONS
// pour les ~14 consommateurs web qui les importaient depuis ce fichier.
export type { LocationFilter } from "@carnet/ui/utils/location";
export { DEFAULT_RADIUS_OPTIONS } from "@carnet/ui/utils/location";
</script>

<script setup lang="ts">
import type { LocationFilter } from "@carnet/ui/utils/location";

defineOptions({ inheritAttrs: false });

const { mapbox } = useCookieConsent();
const isMobile = useIsMobile("(max-width: 639.98px)");

const filter = defineModel<LocationFilter>("filter", { default: () => ({}) });
</script>

<template>
  <AppLocationSearch v-model:filter="filter" :mapbox-allowed="mapbox" :is-mobile="isMobile" v-bind="$attrs" />
</template>
